import Preact, { Fragment, h } from "preact";
import constants from "../../../constants";
import { RouteLogo } from "../../../assets/RouteLogo";
import { renderComboLogo } from "../../../assets/renderComboLogo";

const WidgetLegacy = ({
  quote,
  payer,
  onOpenModalClick,
  status,
  mode,
  alignment,
  variant,
  onToggleKeyDown,
  toggle,
  toggleHandler,
  getMessageForVoiceOver,
  onKeyDown,
  isWidgetDefaultVariant,
}) => {
  return (
    <div className={`pw-container legacy`} data-container>
      <div className="pw-widget" data-widget>
        <div className="pw-content-wrapper">
          <div className="pw-title-row">
            <div
              className="pw-logo"
              data-logo
              tabIndex="0"
              onClick={onOpenModalClick}
            >
              <RouteLogo
                variant={isWidgetDefaultVariant ? "default" : "legacy"}
              />
            </div>

            <div className="pw-title" tabIndex="0">
              {isWidgetDefaultVariant
                ? "Package Protection"
                : "Green Package Protection"}
            </div>
          </div>

          <div
            className={`pw-content ${
              isWidgetDefaultVariant && "default-content"
            }`}
          >
            <div
              className="pw-subtitle"
              data-subtitle-legacy
              tabIndex="0"
              onKeyDown={onKeyDown}
            >
              {isWidgetDefaultVariant ? (
                <span className="pw-subtitle-text">
                  Against loss, theft, or damage in transit, and instant
                  resolution with Route.{" "}
                  <span
                    className="pw-learn-more"
                    onClick={onOpenModalClick}
                    title="Learn more"
                    alt="info icon"
                    data-testid="pw-learn-more"
                  >
                    <svg
                      fill="none"
                      height="10"
                      viewBox="0 0 10 10"
                      width="10"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="#6a6a6d">
                        <path
                          clip-rule="evenodd"
                          d="m5 8.75c2.07107 0 3.75-1.67893 3.75-3.75s-1.67893-3.75-3.75-3.75-3.75 1.67893-3.75 3.75 1.67893 3.75 3.75 3.75zm0 1.25c2.76142 0 5-2.23858 5-5s-2.23858-5-5-5-5 2.23858-5 5 2.23858 5 5 5z"
                          fill-rule="evenodd"
                        />
                        <path
                          clip-rule="evenodd"
                          d="m4.375 7.5v-3.125h1.25v3.125z"
                          fill-rule="evenodd"
                        />
                        <circle cx="5" cy="3.125" r=".625" />
                      </g>
                    </svg>
                  </span>
                </span>
              ) : (
                <span className="pw-subtitle-text" data-subtitle-legacy>
                  Safe delivery with instant resolution. Certified carbon
                  neutral shipping.
                </span>
              )}
            </div>
          </div>
        </div>
        {payer === "merchant" ? (
          <span className="pw-free-toggle" tabIndex="0">
            FREE
          </span>
        ) : (
          <div className="pw-toggle-wrapper">
            <div
              className="pw-switch-class"
              tabIndex="0"
              onKeyDown={onToggleKeyDown}
              data-toggle={toggle}
            >
              <div
                className="pw-switch"
                data-toggle={toggle}
                onClick={toggleHandler}
                data-testid="toggle"
                role="switch"
                aria-live="polite"
                aria-checked={toggle}
                id="speakerPower"
                title={getMessageForVoiceOver(toggle == "true")}
                aria-label={getMessageForVoiceOver(toggle == "true")}
              >
                <div className="pw-ellipse"></div>
                <div className="pw-toggle">&nbsp;</div>
              </div>
            </div>
            {isWidgetDefaultVariant && (
              <div
                className={`pw-price pw-quote quote ${
                  payer === "merchant" && "merchant-paid"
                }`}
                data-widget-label
                tabIndex="0"
                data-testid="quote"
              >
                {quote}
              </div>
            )}
          </div>
        )}
      </div>
      <div className="pw-footer">
        {isWidgetDefaultVariant ? (
          <div className="pw-green-only">
            <div
              className={`pw-green ${
                payer !== "merchant" && toggle === "false" ? "grayed-badge" : ""
              }`}
              tabIndex="0"
            >
              {mode !== "dark" && (
                <img
                  className="tree-sticker"
                  aria-label="tree-sticker"
                  src={`${
                    toggle === "true" || payer === "merchant"
                      ? constants.baseURL +
                        "/assets/tree-sticker-26-gradient-light.svg"
                      : constants.baseURL +
                        "/assets/tree-sticker-26-grey-light.svg"
                  }`}
                  data-testid="green-logo"
                />
              )}
              {mode === "dark" && (
                <img
                  className="tree-sticker"
                  aria-label="tree-sticker"
                  src={`${
                    toggle === "true" || payer === "merchant"
                      ? constants.baseURL +
                        "/assets/tree-sticker-26-gradient-dark.svg"
                      : constants.baseURL +
                        "/assets/tree-sticker-26-grey-dark.svg"
                  }`}
                  data-testid="green-logo"
                />
              )}

              <div className="full-carbon-text">
                <span
                  className="carbon-text-100"
                  data-toggle={payer === "merchant" || toggle}
                >
                  {`100% `}
                </span>
                <span
                  className="carbon-text"
                  data-toggle={payer === "merchant" || toggle}
                >
                  Carbon Neutral Shipping
                </span>
              </div>
              <div className="vertical-bar"></div>
              <div className="carbon-text-route">
                {renderComboLogo(mode, toggle)}
              </div>
            </div>
          </div>
        ) : (
          <>
            <span
              className="infobox"
              onClick={onOpenModalClick}
              data-testid="infobox"
            >
              <span id="Route Trademark" className="pw-footer-left">
                Powered by
                {mode === "dark" && (
                  <img
                    className="pw-route-logo"
                    src={`${constants.baseURL}/assets/route-logo-black.svg`}
                    alt="Route Logo"
                    data-testid="route-trademark-logo"
                  />
                )}
                {mode !== "dark" && (
                  <img
                    className="pw-route-logo"
                    src={`${constants.baseURL}/assets/route-logo-default.svg`}
                    alt="Route Logo"
                    data-testid="route-trademark-logo"
                  />
                )}
              </span>
              <img
                className="infobox-image"
                src={`${constants.baseURL}/assets/info-icon.svg`}
                alt="Infobox"
              ></img>
            </span>
            <div
              className={`pw-price quote pw-footer-right ${
                payer === "merchant" && "merchant-paid"
              }`}
              data-widget-label
              tabIndex="0"
              data-testid="quote"
            >
              {quote}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WidgetLegacy;
